module.exports = __webpack_public_path__ + "h5/img/yljbj.da2b5084.png";